function IconTiktok() {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5179_46765)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4876 0C12.8176 2.83828 14.4018 4.53045 17.1561 4.71047V7.90279C15.5599 8.05881 14.1618 7.53675 12.5356 6.55266V12.5233C12.5356 20.108 4.26678 22.4782 0.942451 17.0417C-1.19376 13.5434 0.114369 7.40474 6.96705 7.15872V10.5251C6.445 10.6091 5.88695 10.7411 5.37689 10.9151C3.85274 11.4311 2.98866 12.3972 3.22868 14.1014C3.69073 17.3657 9.67933 18.3318 9.18128 11.9532V0.0060006H12.4876V0Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_5179_46765">
          <rect width="17.1557" height="20" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { IconTiktok };
